export class Rect {
  bottom: number;
  left: number;
  right: number;
  top: number;
}

export class MonitorInfo {
  primaryMonitor: {
    monitorRect: Rect;
    availableRect: Rect;
    displayDeviceActive: boolean;
  } = null;

  nonPrimaryMonitors: any[];

  virtualScreen: Rect;
}

export class WindowOptions {
  minWidth?: number;
  minHeight?: number;
  maxWidth?: number;
  maxHeight?: number;
  minimizable?: boolean;
  maximizable?: boolean;
  resizable?: boolean;
  alwaysOnTop?: boolean;
  readonly modal?: boolean;
}

export const MAIN_FRAME_ID: string = "__main__";
